import { Navigate, createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { UsersPage } from "@/features/users";
import { hasPermission, useAuth } from "@/shared/auth";

function UsersRoute(): JSX.Element {
  const { user } = useAuth();
  // Direct-URL guard: users without read access are sent to their default landing.
  if (!hasPermission(user, "users:read")) {
    return <Navigate to="/" />;
  }
  return <UsersPage canManage={hasPermission(user, "users:manage")} />;
}

export const Route = createFileRoute("/_authenticated/users")({
  component: UsersRoute,
});
